import { render } from "./Palyamunka.vue?vue&type=template&id=51e1b952"
import script from "./Palyamunka.vue?vue&type=script&lang=js"
export * from "./Palyamunka.vue?vue&type=script&lang=js"

import "./Palyamunka.vue?vue&type=style&index=0&id=51e1b952&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__